export default {
  toggleLoading(state, loading) {
    state.loading = loading;
  },
  toggleLoadingExport(state, loadingExporting) {
    state.loadingExporting = loadingExporting;
  },
  setlogsReverse(state, logsReverse) {
    state.logsReverse = logsReverse;
  },
  setListStatus(state, listStatus) {
    state.listStatus = listStatus;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/reverse/store/mutations.js